import React from 'react';
import { Building2, TrendingUp, Briefcase, LineChart } from 'lucide-react';
export const InvestmentSection = () => {
  const investmentAreas = [{
    title: 'Private Equity',
    description: 'We partner with established businesses seeking growth capital and operational expertise. Our private equity investments focus on middle-market companies with proven business models and opportunities for operational improvements and strategic expansion.',
    icon: <Building2 size={40} className="text-[#38b2ac]" data-id="element-179" />
  }, {
    title: 'Venture Capital',
    description: 'Our venture investments target early and growth-stage companies with disruptive technologies and scalable business models. We provide not only capital but also strategic guidance, industry connections, and operational support to accelerate growth.',
    icon: <TrendingUp size={40} className="text-[#38b2ac]" data-id="element-180" />
  }, {
    title: 'Business Acquisitions',
    description: 'We pursue selective acquisitions of established businesses with strong cash flows and defensible market positions. Our approach emphasizes preserving company legacy while implementing strategic improvements to drive long-term value creation.',
    icon: <Briefcase size={40} className="text-[#38b2ac]" data-id="element-181" />
  }, {
    title: 'Real Asset Investments',
    description: 'Our real asset strategy focuses on investments in infrastructure, real estate, and natural resources that provide stable cash flows and inflation protection. We seek opportunities with strong underlying fundamentals and potential for value appreciation.',
    icon: <LineChart size={40} className="text-[#38b2ac]" data-id="element-182" />
  }];
  return <section id="investments" className="py-20 bg-white" data-id="element-183">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-186">
            Investment Focus
          </h2>
          <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-187"></div>
          <p className="text-xl text-gray-600" data-id="element-188">
            Strategic capital deployment across complementary investment
            strategies
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-189">
          {investmentAreas.map((area, index) => <div key={index} className="bg-gray-50 rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-190">
              <div className="mb-6" data-id="element-191">{area.icon}</div>
              <h3 className="text-2xl font-semibold mb-4 text-[#0a2351]" data-id="element-192">
                {area.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-193">
                {area.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};